export const JOURNAL = {
  page: "journal-page",
  hero: "journal-hero",
  heroCta: "journal-hero-cta",
  featured: "journal-featured",
  featuredLink: "journal-featured-link",
  categoryChip: "journal-category-chip",
  searchInput: "journal-search-input",
  articleCard: "journal-article-card",
  articleLink: "journal-article-link",
  newsletterEmail: "journal-newsletter-email",
  newsletterSubmit: "journal-newsletter-submit",
  newsletterSuccess: "journal-newsletter-success",
  empty: "journal-empty",
};

export const ARTICLE = {
  page: "article-page",
  title: "article-title",
  producerTake: "article-producer-take",
  shareWhatsapp: "article-share-whatsapp",
  shareCopy: "article-share-copy",
  related: "article-related",
  back: "article-back",
};

export const JOURNAL_ADMIN = {
  page: "journal-admin-page",
  newButton: "admin-new-article",
  articleRow: "admin-article-row",
  editButton: "admin-edit-article",
  deleteButton: "admin-delete-article",
  form: "admin-article-form",
  titleInput: "admin-title-input",
  dekInput: "admin-dek-input",
  bodyInput: "admin-body-input",
  producerTakeInput: "admin-producer-take-input",
  categorySelect: "admin-category-select",
  coverInput: "admin-cover-input",
  tagsInput: "admin-tags-input",
  brandInput: "admin-brand-input",
  industryInput: "admin-industry-input",
  countryInput: "admin-country-input",
  yearInput: "admin-year-input",
  featuredToggle: "admin-featured-toggle",
  statusSelect: "admin-status-select",
  saveButton: "admin-save-article",
  cancelButton: "admin-cancel-article",
};
